
import { Courier } from '../types';

export const mockCouriers: Courier[] = [
  {
    id: 'courier-1',
    name: 'Иван Петров',
    email: 'ivan.petrov@example.com',
    phone: '+7 (922) 123-4567',
    status: 'active',
    totalRentals: 4,
    registeredAt: '2023-10-15',
    registrationDate: '2023-10-15',
    avatar: 'https://i.pravatar.cc/150?img=1',
    deal_number: 'D-2023-001',
    tariff: 'Месяц',
    amo_deal_id: '12345678',
    amo_contact_id: '87654321',
    telegram_id: '@ivan_petrov',
    passport_number: '4511 789456',
    registration_address: 'г. Москва, ул. Ленина, д. 10, кв. 15',
    rental_start_ts: 1715034990,
    rental_end_ts: 1717713390,
    rental_end_human: '7 июня 2024',
    last_payment_date: '2024-05-07',
    comments: 'Постоянный клиент',
    has_paid: true
  },
  {
    id: 'courier-2',
    name: 'Анна Сидорова',
    email: 'anna.sidorova@example.com',
    phone: '+7 (923) 456-7890',
    status: 'active',
    totalRentals: 2,
    registeredAt: '2023-11-20',
    registrationDate: '2023-11-20',
    avatar: 'https://i.pravatar.cc/150?img=5',
    deal_number: 'D-2023-002',
    tariff: 'Неделя',
    telegram_id: '@anna_sidorova',
    avito_id: 'avito_12345',
    passport_number: '4522 123456',
    registration_address: 'г. Санкт-Петербург, пр. Невский, д. 20, кв. 30',
    rental_start_ts: 1714862190,
    rental_end_ts: 1715466990,
    rental_end_human: '12 мая 2024',
    last_payment_date: '2024-05-05',
    has_paid: true
  },
  {
    id: 'courier-3',
    name: 'Алексей Иванов',
    email: 'alexey.ivanov@example.com',
    phone: '+7 (924) 789-0123',
    status: 'inactive',
    totalRentals: 1,
    registeredAt: '2023-12-05',
    registrationDate: '2023-12-05',
    avatar: 'https://i.pravatar.cc/150?img=3',
    deal_number: 'D-2023-003',
    tariff: 'Месяц',
    vk_id: 'vk_54321',
    passport_number: '4533 654321',
    registration_address: 'г. Екатеринбург, ул. Ленина, д. 15, кв. 7',
    rental_start_ts: 1714430190,
    rental_end_ts: 1717108590,
    rental_end_human: '31 мая 2024',
    last_payment_date: '2024-04-30',
    comments: 'Задержка с возвратом велосипеда',
    has_paid: false
  },
  {
    id: 'courier-4',
    name: 'Елена Смирнова',
    email: 'elena.smirnova@example.com',
    phone: '+7 (925) 012-3456',
    status: 'active',
    totalRentals: 3,
    registeredAt: '2024-01-10',
    registrationDate: '2024-01-10',
    avatar: 'https://i.pravatar.cc/150?img=10',
    deal_number: 'D-2024-001',
    tariff: 'Неделя',
    amo_deal_id: '23456789',
    amo_contact_id: '98765432',
    telegram_id: '@elena_smirnova',
    passport_number: '4544 987654',
    registration_address: 'г. Новосибирск, ул. Кирова, д. 25, кв. 42',
    rental_start_ts: 1714689390,
    rental_end_ts: 1715294190,
    rental_end_human: '10 мая 2024',
    last_payment_date: '2024-05-03',
    has_paid: true
  },
  {
    id: 'courier-5',
    name: 'Дмитрий Козлов',
    email: 'dmitry.kozlov@example.com',
    phone: '+7 (926) 345-6789',
    status: 'inactive',
    totalRentals: 0,
    registeredAt: '2024-02-15',
    registrationDate: '2024-02-15',
    avatar: 'https://i.pravatar.cc/150?img=8',
    deal_number: 'D-2024-002',
    tariff: 'Месяц',
    avito_id: 'avito_54321',
    passport_number: '4555 135792',
    registration_address: 'г. Казань, ул. Баумана, д. 30, кв. 12',
    rental_start_ts: 1710873390,
    rental_end_ts: 1713551790,
    rental_end_human: '20 апреля 2024',
    last_payment_date: '2024-03-20',
    comments: 'Не продлил аренду',
    has_paid: false
  }
];
